/**
 * Polyfills for old/dumb browsers.
 */

// Polyfill for Internet Explorer to support css variables
if (window.MSInputMethodContext && document.documentMode) {
    import('./ie11CssVarsPolyfill');
}



/**
 * `forEach` polyfill for Internet Explorer.
 */
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

/**
 * `closest` polyfill for Internet Explorer.
 */
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}
if (!Element.prototype.closest) {
    Element.prototype.closest = function(s) {
        var el = this;
        do {
            if (Element.prototype.matches.call(el, s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}





// WEBPACK FOOTER //
// ./src/assets/polyfills/polyfills.js